/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import { Box } from '@mui/material';

/** A moving stroke follows the actual pill perimeter, including while its width changes. */
function LauncherWorkingOutline() {
  return (
    <Box
      component="svg"
      role="progressbar"
      aria-label="Agent working"
      sx={{
        position: 'absolute',
        inset: 0,
        width: '100%',
        height: '100%',
        overflow: 'visible',
        pointerEvents: 'none',
        '& rect': {
          width: 'calc(100% - 1.5px)',
          height: 'calc(100% - 1.5px)',
          filter: 'drop-shadow(0 0 2px #C084FC)',
          animation: 'agent-outline-travel 1800ms linear infinite',
        },
        '@keyframes agent-outline-travel': { to: { strokeDashoffset: -100 } },
        '@media (prefers-reduced-motion: reduce)': {
          '& rect': { animation: 'none', strokeDasharray: '100 0', opacity: 0.8 },
        },
      }}
    >
      <rect
        x="0.75"
        y="0.75"
        rx="14.25"
        pathLength="100"
        fill="none"
        stroke="#C084FC"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeDasharray="24 76"
      />
    </Box>
  );
}

export default LauncherWorkingOutline;
